import { memo, useMemo, type FC } from 'react';
import { StorableImage } from 'StorableImage/StorableImage';
import { twMerge } from 'tailwind-merge';

// See comment near frontRoyalStoreApi/getStorableImage for an explanation of which
// images get cached forever and which do not. The default has to be false because we want
// it to be false for lesson images, and those are hard to change because they are included in
// the lesson content.
type Props = {
    src: string;
    size?: 7.5 | 10;
    desktopSize?: 7.5 | 10;
    alt: string;
    cacheForever: boolean;
    fadeInOnLoad?: boolean;
};

const getClassName = (size: Props['size'], desktopSize: Props['desktopSize']) => {
    const sizeClass = size === 7.5 ? 'h-7.5 w-7.5' : 'h-10 w-10';
    let desktopSizeClass = '';
    if (desktopSize) {
        desktopSizeClass = desktopSize === 7.5 ? 'md:h-7.5 md:w-7.5' : 'md:h-10 md:w-10';
    }

    return twMerge('inline-flex', sizeClass, desktopSizeClass);
};

export const ContentItemIcon: FC<Props> = memo(
    ({ src, size = 10, desktopSize, alt, cacheForever = false, fadeInOnLoad = true }) => {
        const className = useMemo(() => getClassName(size, desktopSize), [size, desktopSize]);

        return (
            <StorableImage
                src={src}
                alt={alt}
                cacheForever={cacheForever}
                fadeInOnLoad={fadeInOnLoad}
                className={className}
            />
        );
    },
);
